import apiClient from './apiClient';

/**
 * Uploads a single file (image or video) via multipart/form-data.
 * @param {File} file - The file object to upload
 * @param {number} containerType - containerType id
 * @param {number} viewTypeId - viewTypeId
 * @returns {Promise<string>} - Resolves to the uploaded file URL
 */
export async function uploadFile({ file }) {
    const formData = new FormData();
    formData.append('file', file);
    const res = await apiClient.post('/minusone-service/file/uploadFile', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });

    const url = res.data?.responseObject?.url || res.data?.responseObject;
    if (!url) throw new Error('Upload failed: no URL returned');
    return url;
}